/**
 * List of input Source type
 */
export enum InputSource {
    QUILT = 'QUILT',
    Investran = 'Investran'
}

export enum IFundMemberType {
    QLCP = "QLCP",
    QCS = "QCS"
}
